import React, { createContext, useState } from 'react';
import { IntlProvider } from 'react-intl';
import translations from './translations';

import config from './config';
const env = process.env.REACT_APP_CLIENT_ENV || 'development';

const Context = createContext();

const IntlProviderWrapper = ({ children }) => {
  const [language, setLanguage] = useState(
    localStorage.getItem('APP_LANG') || config[env].lang
  );

  return (
    <Context.Provider value={{ setLanguage }}>
      <IntlProvider
        key={
          translations[language]
            ? language
            : translations[language.split('-')[0]]
            ? language.split('-')[0]
            : config[env].lang
        }
        locale={
          translations[language]
            ? language
            : translations[language.split('-')[0]]
            ? language.split('-')[0]
            : config[env].lang
        }
        messages={
          translations[language]
            ? translations[language]
            : translations[language.split('-')[0]]
            ? translations[language.split('-')[0]]
            : translations[config[env].lang]
        }
        defaultLocale={config[env].lang}
      >
        {children}
      </IntlProvider>
    </Context.Provider>
  );
};

export { IntlProviderWrapper, Context as IntlContext };
